module.exports = __webpack_public_path__ + "img/6_46.7ea96dfc.png";